import React from 'react';
import {Table} from '../../../components/table/Table';
import {useInvoke} from '../../../controllers/useInvoke';

const AD_HEADLINE = {
  field: 'ad_head_line',
  header: 'Ad Headline',
  responsive: 'sm',
};

const URL = {
  field: 'ad_display_url',
  header: 'URL',
};

const CREATEDON = {
  type: 'date',
  field: 'created_on',
  header: 'Created On',
};

const COMPLETEDON = {
  type: 'date',
  field: 'completed_date',
  header: 'Completed On',
  responsive: 'sm',
};

export const CreativeAdActiveTable = props => {
  const {
    route: {params},
    navigation,
    searchValue,
  } = props;
  const {communicationFilter} = params;
  const invoke = useInvoke({method: 'put'});
  const markComplete = ({row}) => {
    invoke({
      uri: `/adcreatives/${row?._id}`,
      props: {
        status: 'completed',
        completed_date: new Date(),
      },
    });
  };
  return (
    <Table
      api={`/ads-creatives`}
      addOnFilter={{
        status: 'active',
        ...communicationFilter,
      }}
      search={searchValue}
      searchFields={'ad_head_line'}
      params={params}
      onRowPress={row => {
        navigation.navigate('edit-ad-creatives', row);
      }}
      columns={[
        AD_HEADLINE,
        URL,
        CREATEDON,
      ]}
      moreActions={[
        {
          title: 'Mark Completed',
          onPress: markComplete,
        },
      ]}
    />
  );
};

export const CreativeAdCompletedTable = ({route: {params}, searchValue}) => {
  const {communicationFilter} = params;
  return (
    <Table
      api={`/ads-creatives`}
      addOnFilter={{
        status: 'completed',
        ...communicationFilter,
      }}
      search={searchValue}
      searchFields={'ad_head_line'}
      params={params}
      columns={[AD_HEADLINE, URL, CREATEDON, COMPLETEDON]}
    />
  );
};
